import { render } from "./collapse.vue?vue&type=template&id=572f5dc5&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=572f5dc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-572f5dc5"

export default script